import { useEffect } from 'react';

/**
 * The terms page is a static file (public/terms.html), so it is readable without
 * JavaScript, as Google's OAuth review requires. Opening /terms directly serves that file;
 * this component only handles in-app links, by loading the static page.
 */
export default function Terms() {
  useEffect(() => { window.location.replace('/terms.html'); }, []);
  return null;
}
